import { render, staticRenderFns } from "./ReceiveAward.vue?vue&type=template&id=6b45ad98&scoped=true&"
import script from "./ReceiveAward.vue?vue&type=script&lang=js&"
export * from "./ReceiveAward.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveAward.vue?vue&type=style&index=0&id=6b45ad98&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b45ad98",
  null
  
)

export default component.exports